import React from "react";
import FadeUp from "@/components/brand/FadeUp";

export const EarlyStageNote = () => {
    return (
        <section className="vfs-section" data-testid="early-stage-section">
            <div className="vfs-container">
                <FadeUp>
                    <div
                        className="vfs-glass p-7 sm:p-10 lg:p-12 max-w-3xl"
                        style={{ borderRadius: 20 }}
                    >
                        <h2 className="vfs-h2 mb-5">
                            Built carefully from the beginning.
                        </h2>
                        <p
                            className="vfs-body text-lg leading-relaxed mb-5"
                            style={{ color: "var(--text-primary)" }}
                        >
                            Vibe for Success, Inc. is a new Florida nonprofit
                            corporation developing its first pilot program. The
                            website will be updated as program dates, partners,
                            sponsors, and participation details are confirmed.
                        </p>
                        <p
                            className="text-sm leading-relaxed"
                            style={{ color: "var(--text-secondary)" }}
                        >
                            We are intentionally starting small so the first
                            group of students receives safe, focused,
                            high-quality support.
                        </p>
                    </div>
                </FadeUp>
            </div>
        </section>
    );
};

export default EarlyStageNote;
